import { render, staticRenderFns } from "./quote-refer-info.vue?vue&type=template&id=4561946e&scoped=true&"
import script from "./quote-refer-info.vue?vue&type=script&lang=js&"
export * from "./quote-refer-info.vue?vue&type=script&lang=js&"
import style0 from "./quote-refer-info.vue?vue&type=style&index=0&id=4561946e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561946e",
  null
  
)

export default component.exports